import { render, staticRenderFns } from "./ArchivoAspirantes.vue?vue&type=template&id=bcac4728&scoped=true"
import script from "./ArchivoAspirantes.vue?vue&type=script&lang=js"
export * from "./ArchivoAspirantes.vue?vue&type=script&lang=js"
import style0 from "./ArchivoAspirantes.vue?vue&type=style&index=0&id=bcac4728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcac4728",
  null
  
)

export default component.exports